export const LOGIN_GOIKO_FWB = 'https://www.goiko.com/account/login'
export const LEGAL_CONDITIONS_GOIKO_URL = 'https://www.goiko.com/es/bases-condiciones/takeaway15descuento/'
export const LEGAL_CONDITIONS_COCACOLA_URL = 'https://www.goiko.com/es/bases-condiciones/takeawaysorteococacola/'
export const LEGAL_CONDITIONS_TAKEAWAY15_URL = 'https://www.goiko.com/es/bases-condiciones/takeaway15-oct/'